<template>

    <div>
        <v-container fluid class="lightPinkBackground py-0">
            
            <v-container class="pb-0">
                <v-row align="center" style="min-height: 150px">
                    <v-col cols="12" sm="12" md="6">
                        <v-row class="">
                            <v-col cols="4" sm="4" md="4"  class="text-center ma-0 pa-0">
                                <v-row class="ma-0 pa-0">
                                    <v-col cols="12" class="ma-0" v-if="doctor.profile_image_path">
                                        <div class="round_img" :style="{ 'background-image': 'url(' + apiUrl +'/storage/'+doctor.profile_image_path + ')' }">
                                        </div>                                                                            
                                    </v-col>                                                                
                                    <v-col cols="12" class="ma-0" v-else>       
                                        <div class="round_img" style="background-image: url('/general/profile_placeholder.svg')">
                                        </div>                                                               
                                    </v-col>                                                                      
                                </v-row>                                            
                            </v-col>
                            <v-col cols="8" sm="8" md="8" class="ma-md-0 pa-md-0 pl-xs-2 d-flex align-center">
                                <v-list class="wrap-normal-list pa-0 lightPinkBackground">
                                    <v-list-item>                                
                                        <v-list-item-content >
                                            <v-list-item-title class="font-26">{{ doctor.salutation }}
                                                {{ doctor.name }}
                                            </v-list-item-title>
                                            <v-list-item-subtitle>
                                            <span v-for="specialization in doctor.specializations"
                                                :key="specialization.id">
                                                {{ specialization.name }}
                                            </span>                                               
                                            </v-list-item-subtitle>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-list>
                            </v-col>
                        </v-row>
                        
                    </v-col>
                    <v-col cols="12" sm="12" md="6" class="text-md-right text-center">
                        <v-chip
                                color="teal"
                                text-color="white"
                                class="mb-2"
                        >
                            <v-avatar left>
                                <v-icon>mdi-checkbox-marked-circle</v-icon>
                            </v-avatar>
                            Registration Verified
                        </v-chip>
                        <div>
                            <v-chip label color="grey" small class="" v-if="!doctor.percent_recommended" outlined>
                                No Recommendations
                            </v-chip>
                            <v-chip label color="orange" outlined small class="white--text" v-if="doctor.percent_recommended < 50 && doctor.percent_recommended > 0">
                                {{ doctor.percent_recommended }}% <v-icon small right>mdi-thumb-up</v-icon>
                            </v-chip>
                            <v-chip label color="green" outlined  small class="white--text" v-if="doctor.percent_recommended >= 50">
                                {{ doctor.percent_recommended }}% <v-icon small right>mdi-thumb-up</v-icon>
                            </v-chip>
                        </div>
                    </v-col>
                </v-row>
            </v-container>
        </v-container>
        <v-container fluid class="py-0">
            <v-container class="pb-0">
                <v-row>
                    <v-col cols="12" sm="12" md="6" class="pb-0">
                        <v-row>
                            <v-col cols="12" sm="12">
                                <v-card outlined>

                                    <v-tabs
                                            v-model="tab"
                                            background-color="lightPinkBackground"
                                    >
                                        <v-tabs-slider></v-tabs-slider>

                                        <v-tab
                                                v-for="i in tabs"
                                                :key="i.key"
                                                :href="`#tab-${i.key}`"
                                        >
                                            <span class="hidden-sm-and-down">
                                                {{ i.title }}
                                            </span>
                                            <span class="hidden-md-and-up">
                                                <v-icon v-text="i.icon" color="primary"></v-icon>
                                            </span>
                                        </v-tab>

                                        <v-tab-item
                                                value="tab-about"
                                        >
                                            <v-list>
                                              <v-list-item>
                                                <v-list-item-content>
                                                  <v-list-item-title class="mb-2"><b>Gender</b></v-list-item-title>
                                                  <v-list-item-subtitle style="text-transform: capitalize;">
                                                    {{ doctor.gender }}
                                                  </v-list-item-subtitle>
                                                </v-list-item-content>
                                              </v-list-item>
                                                <v-list-item>
                                                    <v-list-item-content>
                                                        <v-list-item-title class="mb-2"><b>Experience</b></v-list-item-title>
                                                        <v-list-item-subtitle>
                                                            {{ doctor.professional_exp }} Years
                                                        </v-list-item-subtitle>
                                                    </v-list-item-content>
                                                </v-list-item>
                                                <v-list-item>
                                                    <v-list-item-content>
                                                        <v-list-item-title class="mb-2"><b>Services</b></v-list-item-title>
                                                        <v-list-item-subtitle class="mb-1">
                                                            - {{ doctor.services }}
                                                        </v-list-item-subtitle>
                                                    </v-list-item-content>
                                                </v-list-item>
                                                <v-list-item>
                                                    <v-list-item-content>
                                                        <v-list-item-title class="mb-2"><b>About Doctor</b></v-list-item-title>
                                                        <v-list-item-subtitle>
                                                    <span v-if="doctor.about">
                                                        {{ doctor.about }}
                                                    </span>
                                                            <span v-else>
                                                        -
                                                    </span>
                                                        </v-list-item-subtitle>
                                                    </v-list-item-content>
                                                </v-list-item>
                                                <v-list-item>
                                                    <v-list-item-content>
                                                        <v-list-item-title class="mb-2"><b>Education</b></v-list-item-title>
                                                        <v-list-item-subtitle>
                                                            <template v-if="doctor.education">
                                                                {{doctor.education.degree_name}}
                                                            </template>
                                                        </v-list-item-subtitle>
                                                        <v-list-item-subtitle>
                                                            {{doctor.education.institute_name}} - {{doctor.education.year}}
                                                        </v-list-item-subtitle>
                                                    </v-list-item-content>
                                                </v-list-item>
                                                <v-list-item>
                                                    <v-list-item-content>
                                                        <v-list-item-title class="mb-2"><b>Registration</b></v-list-item-title>
                                                        <v-list-item-subtitle>
                                                            {{doctor.registration.registration_number}} - {{doctor.registration.council}} - {{doctor.registration.year}}
                                                        </v-list-item-subtitle>
                                                    </v-list-item-content>
                                                </v-list-item>
                                            </v-list>

                                        </v-tab-item>
                                        <v-tab-item value="tab-rating_review">   
                                            <v-row v-if="reviewSectionLoading" class="text-center">
                                                    <v-col cols="12">
                                                        <br><br><br>
                                                        <v-progress-circular
                                                                size="50"
                                                                color="primary"
                                                                indeterminate
                                                        ></v-progress-circular>
                                                        <br><br><br>
                                                    </v-col>
                                                </v-row>
                                            <template v-else>
                                                <v-col cols="12" sm="12" class="text-center">
                                                           <v-btn v-if="show_review === false" @click="giveReview()" class="accent white--text mt-4"
                                                                  rounded>
                                                               Give Review
                                                               <v-icon right>mdi-arrow-right</v-icon>
                                                           </v-btn>
                                                </v-col>   
                                                
                                                <v-form v-if="show_review === true">
                                                   <v-row no-gutters class="ml-3 mr-3 mt-2">
                                                       <v-col cols="12">
                                                            <h4>Would you recommend this doctor to others?</h4>
                                                        </v-col>
                                                        <v-col cols="12">
                                                        
                                                        <v-chip-group                                                        
                                                        mandatory                                                             
                                                        v-model="reviewIsrecommended"                                                   
                                                        active-class="green--text text--accent-4"
                                                        >                                                        
                                                        <v-chip
                                                        :outlined="reviewIsrecommended==='false'"
                                                        class="mr-2"
                                                        color="green"
                                                        small
                                                        value="true"
                                                        >
                                                        <span :class="reviewIsrecommended==='true' ? 'white--text' : 'green-text' ">Yes</span>
                                                        
                                                            <v-icon small :color="reviewIsrecommended==='true' ? 'white' : 'green' " right>mdi-thumb-up</v-icon>
                                                        </v-chip>
                                                        <v-chip     
                                                        small                                                                                                           
                                                        value="false"
                                                        :outlined="reviewIsrecommended==='true'"                                                                                                                
                                                        color="red"                                                        
                                                        >
                                                        <span  :class="reviewIsrecommended==='false' ? 'white--text' : 'red-text' ">No</span>
                                                            
                                                            <v-icon small right :color="reviewIsrecommended==='false' ? 'white' : 'red' ">mdi-thumb-down</v-icon>
                                                        </v-chip>
                                                        </v-chip-group>
                                                        </v-col>
                                                       <v-col cols="12" sm="12" class="mt-5">
                                                           <v-textarea placeholder="How was your experience?" solo flat rows=2
                                                                       background-color="grey lighten-3"
                                                                       v-model="reviewDescription"></v-textarea>
                                                       </v-col>
                                                       
                                                       
                                                       <v-col cols="12" sm="12" class="text-center">
                                                           <v-btn @click.prevent="submitReview" class="accent white--text"
                                                                  :loading="reviewLoading"
                                                                  :disabled="reviewLoading"
                                                                  rounded>
                                                               Submit Review
                                                               <v-icon right>mdi-arrow-right</v-icon>
                                                           </v-btn>
                                                       </v-col>
                                                       <v-col cols="12" sm="12" class="text-center mt-4">
                                                           <v-divider></v-divider>
                                                       </v-col>
                                                       
                                                   </v-row>
                                               </v-form>    
                                               <template v-if="show_review === false">
                                                   <v-list >
                                             
                                                        <template v-for="(review, index) in reviews">
                                                                <v-list-item :key="review.id">
                                                                    <v-list-item-content>
                                                                        <v-list-item-title class="mb-2"><b>{{ review.patient.name }}</b>
                                                                            <span :style="alignRight">                                                                                                                                        
                                                                                
                                                                                <v-list-item-subtitle v-if="review.is_recommended===true" class="green--text">
                                                                                    <v-icon small class="mr-2" color="green">mdi-thumb-up</v-icon>Recommends
                                                                                </v-list-item-subtitle>
                                                                                <v-list-item-subtitle v-if="review.is_recommended===false" class="red--text">
                                                                                    <v-icon small class="mr-2" color="red">mdi-thumb-down</v-icon>Does not Recommend
                                                                                </v-list-item-subtitle>
                                                                            </span>
                                                                        </v-list-item-title>
                                                                        <div>{{ review.description }}</div>
                                                                                                                                
                                                                    </v-list-item-content>        
                                                                    
                                                                
                                                                                                                    
                                                            </v-list-item>        
                                                            <v-divider :key="index" v-if="index + 1 < reviews.length"></v-divider>    
                                                        </template>                                                                                            
                                                    </v-list>
                                                    <div v-if="reviews.length === 0" class="text-center my-12">
                                                        <v-icon large>mdi-alert</v-icon>
                                                        <br>
                                                        <h3 class="font-weight-regular">No Ratings or Reviews Found</h3>
                                                    </div>
                                               </template>       
                                            </template>

                                                                  
                                         
                                        </v-tab-item>

                                        <v-tab-item
                                                value="tab-q_a"
                                        >
                                            <v-col cols="12" sm="12" md="12" class="pa-0 question-list">
                                                <v-card flat class="mb-2">
                                                    <v-list three-line class="py-0">
                                                        <v-list-item-group
                                                            v-for="(question, key) in questionsList"
                                                            :key="key">
                                                            <v-divider></v-divider>
                                                            <v-list-item class="cursor-pointer" @click="$router.push({name: 'askAQuestionDetail', params: {id: question.id, slug: getSlugFromString(question.title)}})">

                                                                <v-list-item-content>
                                                                    <v-list-item-title class="py-1">
                                                                        <span>{{ question.title }}</span>
                                                                    </v-list-item-title>
                                                                    <v-list-item-subtitle v-text="question.description" class="mb-1">

                                                                    </v-list-item-subtitle>
                                                                    <v-list-item-subtitle class="font-weight-bold py-1">
                                                                        <v-row no-gutters>
                                                                            <v-col cols="6" class="text-left">
                                                                                {{ question.patient.gender | capitalize}}, {{ question.patient.birth_year | age }}
                                                                            </v-col>
                                                                            <v-col cols="6" class="text-right">
                                                                                {{ question.created_at | readableDateTime }}
                                                                            </v-col>
                                                                        </v-row>
                                                                    </v-list-item-subtitle>
                                                                </v-list-item-content>

                                                            </v-list-item>
                                                            
                                                        </v-list-item-group>
                                                    </v-list>
                                                </v-card>
                                            </v-col>
                                            <div class="text-center my-12" v-if="!questionsList.length">
                                                <v-icon large>mdi-alert</v-icon>
                                                <br>
                                                <h3 class="font-weight-regular">No Question or Answers Found</h3>
                                            </div>
                                        </v-tab-item>
                                        <v-tab-item
                                                value="tab-articles"
                                        >
                                            <div class="text-center my-12">
                                                <v-icon large>mdi-alert</v-icon>
                                                <br>
                                                <h3 class="font-weight-regular">No Articles Found</h3>
                                            </div>
                                        </v-tab-item>
                                    </v-tabs>
                                </v-card>
                            </v-col>
                        </v-row>
                    </v-col>
                    <v-col cols="12" sm="12" md="6">
                        <v-row>
                            <v-col cols="12" sm="12" md="12">
                                <v-card outlined>

                                    <v-tabs
                                            background-color="lightPinkBackground"
                                    >
                                        <v-tabs-slider></v-tabs-slider>

                                        <v-tab
                                                href="#tab-clinic"
                                        >
                                            Clinic Appointment
                                        </v-tab>

                                        <v-tab-item
                                                value="tab-clinic"
                                        >
                                            <v-list class="wrap-normal-list" v-if="clinicLoading">                                        
                                                    <template>
                                                        <v-list-item >
                                                            <v-list-item-content class="d-flex flex-center">
                                                                <v-progress-circular
                                                                indeterminate
                                                                color="primary"
                                                                ></v-progress-circular>
                                                            </v-list-item-content>
                                                        </v-list-item>
                                                    </template>
                                            </v-list>
                                            <v-list  class="wrap-normal-list" v-else-if="!clinicLoading && clinicsList.length && doctor.available_clinic">
											<template
												v-for="(clinic, index) in clinicsList"
												
											>
											<v-list-group    					
													:key="clinic.id"											
													v-model="clinic.active"                                                
													no-action                       
													:value="index == 0 ? 'true' : 'true'"											
                                                >

                                                    <template v-slot:activator>
                                                        <v-list-item-content>                                                            
                                                                <v-col cols="12" sm="12" md="7" class="pl-0 pt-0 pb-0 pr-0">
                                                                <v-list-item-title>{{ clinic.name }}</v-list-item-title>
                                                            </v-col>
                                                                                                                        
                                                        </v-list-item-content>
                                                    </template>
                                                    <v-divider></v-divider>
                                                <v-list-item class="pl-0" v-if="clinic.fees[0] && clinic.doctor_schedule.length">
                                                    <v-list-item-avatar>
                                                        <v-icon color="primary">mdi-calendar</v-icon>
                                                    </v-list-item-avatar>
                                                    <v-list-item-content v-if="clinic.fees[0]" style="display:block !important;">
                                                            <v-btn @click.prevent="" small class="accent white--text"                                                               
                                                               @click="goForBooking(doctor.id,clinic,'clinic')"
                                                               >Book Appointment
                                                                </v-btn>                                                            
                                                    </v-list-item-content>
                                                </v-list-item>
                                                
                                                <v-divider></v-divider>
                                                <v-list-item class="pl-0">
                                                    <v-list-item-avatar>
                                                        <v-icon color="primary">mdi-map-marker</v-icon>
                                                    </v-list-item-avatar>
                                                    <v-list-item-content>
                                                        <v-list-item-subtitle class="d-flex justify-space-between align-center">
                                                            <div>
                                                                {{clinic.address}}
                                                            </div>
                                                            <v-btn @click.prevent="openMap(clinic)" x-small class="accent white--text" depressed>
                                                                View On Map
                                                            </v-btn>    
                                                        </v-list-item-subtitle>
                                                    </v-list-item-content>
                                                </v-list-item>
                                                <v-divider></v-divider>
                                                <v-list-item class="pl-0">
                                                    <v-list-item-avatar class="align-self-start">
                                                        <v-icon  color="primary">mdi-clock</v-icon>
                                                    </v-list-item-avatar>
                                                    <v-list-item-content>
                                                        <template v-if="clinic.doctor_schedule.length">
                                                            <v-list-item-subtitle v-for="(schedule,index) in clinic.doctor_schedule" :key="schedule.id">
                                                                <v-divider v-if="schedule.header && index!==0" class="mt-2 mb-2"></v-divider>
                                                                <div class="mt-2" v-if="schedule.header">
                                                                    {{  moment().day(schedule.day).format('dddd')}}                                                                
                                                                </div>
                                                                <div class="mt-1" v-else>
                                                                    
                                                                    {{ moment(schedule.start_time, [moment.ISO_8601, 'HH:mm:ss']).format('hh:mm A') }} to {{ moment(schedule.end_time, [moment.ISO_8601, 'HH:mm:ss']).format('hh:mm A') }}
                                                                </div>
                                                                
                                                            </v-list-item-subtitle>
                                                        </template>
                                                        <v-list-item-subtitle v-else>                                                                
                                                                <div class="mt-2">
                                                                    No Schedule
                                                                </div>                                                                                                                            
                                                            </v-list-item-subtitle>
                                                    </v-list-item-content>
                                                </v-list-item>
                                                <v-divider></v-divider>
                                                <v-list-item class="pl-0">
                                                    <v-list-item-avatar>
                                                        <v-icon color="primary">mdi-currency-inr</v-icon>
                                                    </v-list-item-avatar>
                                                    <v-list-item-content v-if="clinic.fees.length">
                                                        <v-list-item-subtitle class="black--text">
                                                            <b>Fees: Rs. {{clinic.fees[0].amount}}</b>
                                                        </v-list-item-subtitle>
                                                    </v-list-item-content>
                                                    <v-list-item-content v-else>
                                                        <v-list-item-subtitle class="black--text">
                                                            <b>Not Mentioned</b>
                                                        </v-list-item-subtitle>
                                                    </v-list-item-content>
                                                </v-list-item>
                                                </v-list-group>
											</template>
                                                

                                                
                                            </v-list>
                                            <v-list v-else>
                                                <v-list-item>                                                        
                                                    <v-list-item-content>
                                                        <v-list-item-subtitle class="black--text text-center">
                                                            Clinic consultation is unavailable
                                                        </v-list-item-subtitle>
                                                    </v-list-item-content>
                                                </v-list-item>
                                            </v-list>
                                        </v-tab-item>
                                    </v-tabs>
                                </v-card>
                            </v-col>
                            <v-col cols="12" sm="12" md="12">
                                <v-card outlined>

                                    <v-tabs
                                            background-color="lightPinkBackground"
                                    >
                                        <v-tabs-slider></v-tabs-slider>

                                        <v-tab
                                                href="#tab-video"
                                        >                                            
                                            Video Consultation                                                                                        
                                        </v-tab>
                                        
                                                                
                                                            
                                        
                                        <v-tab-item
                                                value="tab-video"
                                        >
                                            <v-list class="wrap-normal-list" v-if="onlineConsultationLoading">                                        
                                                    <template>
                                                        <v-list-item >                                                    
                                                            <v-list-item-content class="d-flex flex-center">
                                                                <v-progress-circular
                                                                indeterminate
                                                                color="primary"
                                                                ></v-progress-circular>
                                                            </v-list-item-content>
                                                        </v-list-item>
                                                    </template>
                                            </v-list>
                                            <v-list class="wrap-normal-list" v-else>
                                              
                                                <template v-if="onlineConsultation && doctor.available_online">

                                                    <v-list-item v-if="onlineConsultation.fee && onlineConsultation.schedule.length">
                                                    <v-list-item-avatar>
                                                        <v-icon color="primary">mdi-calendar</v-icon>
                                                    </v-list-item-avatar>
                                                    <v-list-item-content style="display:block !important;">
                                                        <v-btn
                                                         @click.prevent="" small class="accent white--text"                                                               
                                                               @click="goForBooking(doctor.id,null,'online')"
                                                               >Book Appointment
                                                                </v-btn>
                                                    </v-list-item-content>
                                                    </v-list-item>
                                                    <v-divider></v-divider>
                                                    <v-list-item>
                                                        <v-list-item-avatar class="align-self-start"> 
                                                            <v-icon color="primary" >mdi-clock</v-icon>
                                                        </v-list-item-avatar>
                                                        <v-list-item-content>
                                                            <template v-if="onlineConsultation.schedule.length">
                                                                <v-list-item-subtitle v-for="(schedule,index) in onlineConsultation.schedule" :key="schedule.id">
                                                                    <v-divider v-if="schedule.header && index!==0" class="mt-2 mb-2"></v-divider>
                                                                    <div class="mt-2" v-if="schedule.header">
                                                                        
                                                                        {{  moment().day(schedule.day).format('dddd')}}                                                                
                                                                    </div>
                                                                    <div class="mt-1" v-else>                                                                    
                                                                        {{ moment(schedule.start_time, [moment.ISO_8601, 'HH:mm:ss']).format('hh:mm A') }} to {{ moment(schedule.end_time, [moment.ISO_8601, 'HH:mm:ss']).format('hh:mm A') }}
                                                                    </div>                                                                
                                                                </v-list-item-subtitle>
                                                            </template>
                                                            <v-list-item-subtitle v-else>                                                                    
                                                                    <div>                                                                        
                                                                        No Schedule
                                                                    </div>                                                                    
                                                            </v-list-item-subtitle>
                                                            
                                                        </v-list-item-content>
                                                    </v-list-item>
                                                    <v-divider></v-divider>
                                                    <v-list-item>
                                                        <v-list-item-avatar>
                                                            <v-icon color="primary">mdi-currency-inr</v-icon>
                                                        </v-list-item-avatar>
                                                        <v-list-item-content v-if="onlineConsultation.fee">
                                                            <v-list-item-subtitle class="black--text">
                                                                <b>Fees: Rs. {{ onlineConsultation.fee.amount }}</b>
                                                            </v-list-item-subtitle>
                                                        </v-list-item-content>
                                                    </v-list-item>
                                                </template>
                                                <v-list-item v-else>                                                        
                                                    <v-list-item-content>
                                                        <v-list-item-subtitle class="black--text text-center">
                                                            Video consultation is unavailable
                                                        </v-list-item-subtitle>
                                                    </v-list-item-content>
                                                </v-list-item>
                                            </v-list>

                                        </v-tab-item>
                                    </v-tabs>
                                </v-card>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
            </v-container>
        </v-container>
        <!--        Login Modal-->
        <v-dialog v-model="loginDialog" max-width="900" persistent>
            <v-card>
                <patient-login @loginResult="loginDone"></patient-login>
                <v-card-actions class="pt-0">
                    <v-spacer></v-spacer>
                    <v-btn text @click.prevent="loginDialog = false">
                        Close
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-row justify="center">
    <v-dialog
      v-model="cantReviewDialog"
      persistent
      max-width="290"
    >
      
      <v-card>
        <v-card-title class="headline">
          Review
        </v-card-title>
        <v-card-text>You cannot review this doctor since you did not have any interaction.</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>          
          <v-btn
            color="green darken-1"
            text
            @click="cantReviewDialog = false"
          >
            Ok
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
    </div>

</template>

<script>
import PatientLogin from "../Login/PatientLogin";
import {mapGetters} from 'vuex';

    export default {
        name: "DoctorProfile",
        components: {
            PatientLogin          
        },
        computed: {
            ...mapGetters([          
                'userInfo'
            ]),
        },
        props: ['doctorId', 'showBooking'],
        
        data() {
            return {
                apiUrl:process.env.VUE_APP_API_URL,
                loginDialog: false,
                detailsLoading: false,
                doctor: {
                    education: {},
                    registration: {},
                    clinics: []
                },
                alignRight: {
                    float:'right'
                },
                menu: false,
                tab: 1,
                tabs: [
                    {
                        'title': 'About',
                        'key': 'about',
                        'icon' : 'mdi-information'
                    },
                    {
                        'title': 'Rating & Review',
                        'key': 'rating_review',
                        'icon' : 'mdi-star'
                    },
                    {
                        'title': 'Q & A',
                        'key': 'q_a',
                        'icon' : 'mdi-help-circle'
                    },
                    // {
                    //     'title': 'Articles',
                    //     'key': 'articles',
                    //     'icon' : 'mdi-notebook-multiple'
                    // }
                ],
                reviews:[],                
                reviewIsrecommended:null,
                reviewDescription:"",                                        
                show_review:false,
                reviewLoading:false,
                questionsList:[],
                clinicsList:[],
                onlineConsultation:null,                
                isMyDoctor:null,
                reviewSectionLoading:false,
                cantReviewDialog:false,
                clinicLoading:false,
                onlineConsultationLoading:false
            };
            
        },
        methods: {
            loginDone() {                
                this.loginDialog = false;
            },
            getReviews() {
                
                this.axios.get(`${process.env.VUE_APP_API_URL}/api/ratings`,{
                    params:{
                        doctor_id:this.doctorId
                    }                    
                }).then((response) => {
                    if(response.data.status == 1){                          
                        
                     this.reviews  = response.data.data

                    }                    
                    
                }).catch((error) => {
                    console.log(error)
                })
                .finally(() => {
                    
                })
            },
            giveReview(){
                if (!this.userInfo) {
                    this.loginDialog = true;
                    return;
                }    
                else{
                    this.getIsMyDoctor()
                }
                
            },
            submitReview() {            
                if (!this.userInfo) {
                    this.loginDialog = true;
                    return;
                }    
                this.reviewLoading = true
                this.axios.post(`${process.env.VUE_APP_API_URL}/api/ratings/doctor/` + this.doctor.id,{                    
                    
                    is_recommended:this.reviewIsrecommended,
                    description:this.reviewDescription,
                    patient_id:this.userInfo.id,
                    
                    
                }).then((response) => {
                    if(response.data.status == 1){                                                      
                        this.show_review = false
                        this.reviewDescription = ""
                        this.getReviews()
                    }                    
                    
                }).catch((error) => {
                    console.log(error)
                })
                .finally(() => {
                    this.reviewLoading = false                                    
                })
            },
            getQuestions() {
                
                this.axios.get(`${process.env.VUE_APP_API_URL}/api/questions`,{
                    params:{
                        doctor_id:this.doctorId
                    }                    
                }).then((response) => {
                    if(response.data.status == 1){                                                  
                     this.questionsList  = response.data.data
                    }                                        
                }).catch((error) => {
                    console.log(error)
                })
                .finally(() => {
                    
                })
            },            
            getDoctorProfile() {
                this.detailsLoading = true
                this.axios.get(`${process.env.VUE_APP_API_URL}/api/doctors/${this.doctorId}`)
                    .then((response) => {
                        this.doctor = response.data.data
                    })
                    .catch(() => {})
                    .finally(() => {
                        this.detailsLoading = false
                    })
            },
            getClinicsAndSchedule() {
                this.clinicLoading = true;
                this.axios.get(`${process.env.VUE_APP_API_URL}/api/clinics/doctor/`+this.doctorId,{
                    params:{
                        timezone:this.$store.getters.timezone
                    }
                }).then((response) => {
                    var clinicData;
                    if(response.data.status == 1){                                                  
                     clinicData  = response.data.data
                     for(var i=0; i< clinicData.length;i++){
                         var doctorSchedule = clinicData[i].doctor_schedule;                                                  
                         clinicData[i].doctor_schedule = this.generateHeaders( doctorSchedule)
                     }
                     this.clinicsList  = clinicData;
                    }                                        
                }).catch((error) => {
                    console.log(error)
                })
                .finally(() => {
                    this.clinicLoading = false;
                })
            },
            getOnlineConsultationSchedule() {
                this.onlineConsultationLoading = true
                this.axios.get(`${process.env.VUE_APP_API_URL}/api/doctors/`+this.doctorId+"/doctor-online-consultation-info",
                {
                    params:{
                        timezone:this.$store.getters.timezone
                    }
                }).then((response) => {
                    var consultationData;
                    if(response.data.status == 1){                                                  
                        consultationData = response.data.data
                                          
                     if(consultationData && consultationData.schedule.length)                     
                        consultationData.schedule = this.generateHeaders(response.data.data.schedule)                     

                        this.onlineConsultation = consultationData
                    }                                        
                }).catch((error) => {
                    console.log(error)
                })
                .finally(() => {
                    this.onlineConsultationLoading = false
                })
            },
            
            generateHeaders(schedule){                
                var newList = schedule;
                var currentDay = null;
                for(var i=0; i< schedule.length;i++){                    
                    let obj = JSON.parse(JSON.stringify(schedule[i]));
                    if(currentDay !== obj.day){
                        obj.header = true
                        newList.splice(i,0,obj)
                    }
                    currentDay = obj.day;                    
                }
                
                return newList;
            },
            goForBooking(doctorId, clinic,apptType) {
                                
                var clinic_id = ""
                if(apptType == 'clinic'){                    
                    clinic_id = clinic.id
                }                                                                    
                this.$router.push({name: 'bookAppointment', query: {id: doctorId, type: apptType, clinic_id:clinic_id}});
            },
            getIsMyDoctor() {
                this.reviewSectionLoading = true;
                this.axios.get(`${process.env.VUE_APP_API_URL}/api/patients/doctor/`+this.doctorId+`/can-rate-doctor`,{
                    params:{
                        doctor_id:this.doctorId
                    }                    
                }).then((response) => {
                    if(response.data.status == 1){                                                  
                        
                        this.isMyDoctor  = response.data.data
                        if(this.isMyDoctor){
                            this.show_review = true
                        }
                        else{
                            this.show_review = false
                            this.cantReviewDialog = true;
                        }
                    }                                     
                    
                }).catch((error) => {
                    console.log(error)
                })
                .finally(() => {
                    this.reviewSectionLoading = false;
                })
            },      
            openMap(clinic){
                var link ='https://www.google.com/maps/search/?api=1&query=' + clinic.latitude + ',' + clinic.longitude
                window.open(link);                
            }
        },
        mounted(){
            
            

            this.getDoctorProfile()
            this.getReviews()
            this.getQuestions()
            this.getClinicsAndSchedule()
            this.getOnlineConsultationSchedule()
            
            

        },
         filters: {
            // readableDateTime: function (value) {
            //     return this.moment(value).format('hh:mm A, D MMM YYYY')
            // },
            // age: function (value) {
            //     return parseInt(this.moment().year()) - parseInt(value) + ' Years'
            // },
            // capitalize: function (value) {
            //     return value !== undefined ? value.charAt(0).toUpperCase() + value.slice(1) : ''
            // },
            
        },
       
    }
</script>
